import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  1: {
    // Exercise num
    unit: "Unit 4",
    id: "SB3-U4-P31-E1",
    audio: "img/FriendsPlus/Page31/Audio/audio-e1-p31.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page31/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/tieude-e1-p31.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page31/E1/4.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/fl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/6.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/pl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/8.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/9.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/bl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/10.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page31/E1/11.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/12.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/fl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/13.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/14.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/pl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/15.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/16.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/bl.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/17.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page31/E1/18.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/19.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/flower.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/20.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/21.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/plag.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/22.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/23.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/plum.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/24.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/25.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/plate.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/26.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/27.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/planket.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/28.jpg" },
        {
          url: "img/FriendsPlus/Page31/E1/29.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/blue.mp3",
        },
        { url: "img/FriendsPlus/Page31/E1/30.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page31/E1/31.jpg" }],
    ],
  },
  2: { // Exercise num
    // Exercise num
    unit: "Unit 4",
    id: "SB3-U4-P31-E2",
    audio: "img/FriendsPlus/Page31/Audio/audio-e2-p31.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page31/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page31/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page31/Audio/tieude-e2-p31.mp3",
        },
        { url: "img/FriendsPlus/Page31/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page31/E2/4.jpg" }],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: "Unit 4",
    id: "SB3-U4-P31-E3",
    audio: "",
    video: "",
    component: DesignUnderLine,
    hideBtnFooter: true,
    totalInput: 9,
    exerciseKey: "img/FriendsPlus/Page31/E3/Key/answerKey.png",
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page31/E3/73.jpg" }],
      [{ url: "img/FriendsPlus/Page31/E3/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page31/E3/2.jpg" },
        { url: "img/FriendsPlus/Page31/E3/3.jpg" },
        { url: "img/FriendsPlus/Page31/E3/4.jpg" },
        { url: "img/FriendsPlus/Page31/E3/5.jpg", input: 1 },
        { url: "img/FriendsPlus/Page31/E3/6.jpg", input: 2 },
        { url: "img/FriendsPlus/Page31/E3/7.jpg", input: 3, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/8.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page31/E3/9.jpg" },
        { url: "img/FriendsPlus/Page31/E3/10.jpg", input: 4, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/11.jpg" },
        { url: "img/FriendsPlus/Page31/E3/12.jpg", input: 5 },
        { url: "img/FriendsPlus/Page31/E3/13.jpg", input: 6 },
        { url: "img/FriendsPlus/Page31/E3/14.jpg", input: 7, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/15.jpg" },
      ],
      [
        // Column6
        { url: "img/FriendsPlus/Page31/E3/16.jpg" },
        { url: "img/FriendsPlus/Page31/E3/17.jpg", input: 8 },
        { url: "img/FriendsPlus/Page31/E3/18.jpg" },
        { url: "img/FriendsPlus/Page31/E3/19.jpg", input: 9 },
        { url: "img/FriendsPlus/Page31/E3/20.jpg" },
        { url: "img/FriendsPlus/Page31/E3/21.jpg", input: 10 },
        { url: "img/FriendsPlus/Page31/E3/22.jpg" },
        { url: "img/FriendsPlus/Page31/E3/23.jpg", input: 11, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/24.jpg" },
      ],
      [
        // Column8
        { url: "img/FriendsPlus/Page31/E3/25.jpg" },
        { url: "img/FriendsPlus/Page31/E3/26.jpg", input: 12 },
        { url: "img/FriendsPlus/Page31/E3/27.jpg" },
        { url: "img/FriendsPlus/Page31/E3/28.jpg", input: 13 },
        { url: "img/FriendsPlus/Page31/E3/29.jpg" },
        { url: "img/FriendsPlus/Page31/E3/30.jpg", input: 14 },
        { url: "img/FriendsPlus/Page31/E3/31.jpg" },
        { url: "img/FriendsPlus/Page31/E3/32.jpg", input: 15, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/33.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page31/E3/34.jpg" }],
      [
        // Column8
        { url: "img/FriendsPlus/Page31/E3/35.jpg" },
        { url: "img/FriendsPlus/Page31/E3/36.jpg", input: 16 },
        { url: "img/FriendsPlus/Page31/E3/37.jpg", input: 17, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/38.jpg" },
        { url: "img/FriendsPlus/Page31/E3/39.jpg", input: 18 },
        { url: "img/FriendsPlus/Page31/E3/40.jpg", input: 19 },
        { url: "img/FriendsPlus/Page31/E3/41.jpg", input: 20 },
        { url: "img/FriendsPlus/Page31/E3/42.jpg" },
      ],
      [
        // Column8
        { url: "img/FriendsPlus/Page31/E3/43.jpg" },
        { url: "img/FriendsPlus/Page31/E3/44.jpg", input: 21 },
        { url: "img/FriendsPlus/Page31/E3/45.jpg", input: 22, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/46.jpg" },
        { url: "img/FriendsPlus/Page31/E3/47.jpg", input: 23 },
        { url: "img/FriendsPlus/Page31/E3/48.jpg", input: 24 },
        { url: "img/FriendsPlus/Page31/E3/49.jpg", input: 25 },
        { url: "img/FriendsPlus/Page31/E3/50.jpg" },
      ],
      [
        // Column8
        { url: "img/FriendsPlus/Page31/E3/51.jpg" },
        { url: "img/FriendsPlus/Page31/E3/52.jpg", input: 26 },
        { url: "img/FriendsPlus/Page31/E3/53.jpg" },
        { url: "img/FriendsPlus/Page31/E3/54.jpg", input: 27 },
        { url: "img/FriendsPlus/Page31/E3/55.jpg", input: 28 },
        { url: "img/FriendsPlus/Page31/E3/56.jpg" },
        { url: "img/FriendsPlus/Page31/E3/57.jpg", input: 29, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/58.jpg" },
      ],
      [
        // Column8
        { url: "img/FriendsPlus/Page31/E3/59.jpg" },
        { url: "img/FriendsPlus/Page31/E3/60.jpg", input: 30 },
        { url: "img/FriendsPlus/Page31/E3/61.jpg" },
        { url: "img/FriendsPlus/Page31/E3/62.jpg", input: 31 },
        { url: "img/FriendsPlus/Page31/E3/63.jpg" },
        { url: "img/FriendsPlus/Page31/E3/64.jpg", input: 32, isCorrect: true },
        { url: "img/FriendsPlus/Page31/E3/65.jpg" },
        { url: "img/FriendsPlus/Page31/E3/66.jpg", input: 33 },
        { url: "img/FriendsPlus/Page31/E3/67.jpg" },
        { url: "img/FriendsPlus/Page31/E3/68.jpg", input: 34 },
        { url: "img/FriendsPlus/Page31/E3/69.jpg" },
        { url: "img/FriendsPlus/Page31/E3/70.jpg", input: 35 },
        { url: "img/FriendsPlus/Page31/E3/71.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page31/E3/72.jpg" }],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P31-E4',
    audio: 'img/FriendsPlus/Page31/Audio/audio-e4-p31.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page31/E4/Key/answerKey.png',
    isAllowSubmit: false,
    maxLength: 2,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E4/1.jpg'},
        { url: 'img/FriendsPlus/Page31/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/tieude-e4-p31.mp3'},
        { url: 'img/FriendsPlus/Page31/E4/3.jpg'},
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E4/4.jpg'},
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E4/5.jpg'},
        { url: 'img/FriendsPlus/Page31/E4/6.jpg', input: true, answer: "bl"},
        { url: 'img/FriendsPlus/Page31/E4/7.jpg'},
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E4/8.jpg'},
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E4/9.jpg'},
        { url: 'img/FriendsPlus/Page31/E4/10.jpg', input: true, answer: "fl"},
        { url: 'img/FriendsPlus/Page31/E4/11.jpg'},
        { url: 'img/FriendsPlus/Page31/E4/12.jpg', input: true, answer: "bl"},
        { url: 'img/FriendsPlus/Page31/E4/13.jpg'},
        { url: 'img/FriendsPlus/Page31/E4/14.jpg', input: true, answer: "pl"},
        { url: 'img/FriendsPlus/Page31/E4/15.jpg'},
      ],      
    ]
  },
  5: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P31-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page31/E5/1.jpg' }]],
  },
}

export default json;